// 审核项点击事件
export const AUDIT_ITEM_CLICK = 'onAuditItemClick'

export const AUDIT_DATA_LIST_CHANGED = 'onAuditDataListChanged'

// 显示审核主页面
export const SHOW_AUDIT_MAIN = 'onShowAuditMain'

// 当审核界而列表上勾选的因子发生变化的事件
export const AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED = 'onAuditMainGridFactorIdsChanged'

// 显示处理面板
export const SHOW_PROCESS_PANEL = 'onShowProcessPanel'

// 当处理面板保存操作时的事件
export const PROCESS_PANEL_SAVE = 'onProcessPanelSave'

// 显示批量处理面板
export const SHOW_BATCH_PROCESS_PANEL = 'onShowBathProcessPanel'

// 提交下一级审核的事件
export const AUDIT_COMMIT = 'onAuditCommit'

// 显示相关性分析弹框
export const SHOW_RELATED_CHARTS_DIALOG = 'onShowRelatedChartsDialog'

// 显示相关性分析弹框
export const GET_COMPARE_TABLE_VISIBLE = 'getCompareTableVisible'



// WEBPACK FOOTER //
// ./src/views/02Data-Audit/01Manual/EventKeys.js